import { Apollo } from 'src/gql/generated';

export function getStorableRoleLabel(role: Apollo.PermissionRole): string {
  switch (role) {
    case Apollo.PermissionRole.Editor:
      return 'edit';
    case Apollo.PermissionRole.Suggester:
      return 'suggest';
    case Apollo.PermissionRole.Commenter:
      return 'comment';
    case Apollo.PermissionRole.Viewer:
      return 'view';
  }
}

export function getDocumentPermissionRoles(): Apollo.PermissionRole[] {
  return [
    Apollo.PermissionRole.Viewer,
    Apollo.PermissionRole.Commenter,
    Apollo.PermissionRole.Suggester,
    Apollo.PermissionRole.Editor,
  ];
}
